import Head from "next/head";

export default function PrivacyPolicyPage() {
  return (
    <div className="container d-flex flex-grow-1">
      <Head>
        <title>นโยบายความเป็นส่วนตัว | {process.env.appName}</title>
        <meta
          name="description"
          content={`นโยบายความเป็นส่วนตัว | ${process.env.appName}`}
        />
        <meta name="robots" content="noindex" />
        <meta
          name="og:title"
          content={`นโยบายความเป็นส่วนตัว | ${process.env.appName}`}
        />
        <meta
          name="og:description"
          content={`นโยบายความเป็นส่วนตัว | ${process.env.appName}`}
        />
      </Head>
      <main className="w-100">
        <div className="mt-2 mb-1 card">
          <div className="px-4 py-2 my-2">
            <h1 className="h4">
              <b>นโยบายความเป็นส่วนตัว</b>
            </h1>
            <p>
              ยินดีต้อนรับเข้าสู่เว็บไซต์ CanCount เราได้จัดทำประกาศ
              ความเป็นส่วนตัวนี้ เพื่อแจ้งให้ทราบถึงนโยบายความเป็นส่วนตัว
              วิธีการที่เก็บรวบรวม ใช้ และเปิดเผย ข้อมูลส่วนบุคคล ที่ท่าน
              (&#34;ผู้ใช้&#34;) ได้ให้สำหรับการใช้งานเว็บไซต์ CanCount
              ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 &#34;PDPA&#34;
              (Personal Data Protection Act)
            </p>
            <h1 className="h4">
              <b>แหล่งข้อมูลที่ทางเราเก็บรวบรวม</b>
            </h1>
            <p>
              <b>ข้อมูลจากท่านโดยตรง</b> ได้แก่ ข้อมูลเมื่อท่านติดต่อทีมงาน
              CanCount และข้อมูลการยอมรับการใช้คุกกี้
            </p>
            <p>
              <b>เทคโนโลยีการติดตาม (Tracking Technology)</b>{" "}
              เมื่อท่านใช้งานเว็บไซต์ของเรา
              ข้อมูลเหล่านั้นอาจได้แก่ชนิดของอุปกรณ์ที่ท่านใช้ หน้าของเว็บไซต์
              CanCount ที่ท่านได้เยี่ยมชม ระยะเวลาที่เยี่ยมชมเว็บไซต์เหล่านั้น
              วันและเวลาที่เข้าชม และสถิติอื่น ๆ ดูข้อมูลเพิ่มเติมได้ที่{" "}
              <a href="#cookie-policy">
                <b>นโยบายเกี่ยวกับคุกกี้ (Cookies Policy)</b>
              </a>
            </p>
            <h1 className="h4">
              <b>ข้อมูลที่ทางเราเก็บรวบรวม</b>
            </h1>
            <p>
              <b>ข้อมูลเกี่ยวกับบุคคล</b> เช่น IP address, Cookie ID,
              ข้อมูลเบราว์เซอร์และข้อมูลอื่น ๆ
              เกี่ยวกับอุปกรณ์ที่ท่านใช้เพื่อเข้าถึงเว็บไซต์
            </p>
            <p>
              <b>ข้อมูลเกี่ยวกับกิจกรรมการใช้งานเว็บไซต์</b> เช่น
              ประวัติในการเยี่ยมชม และปฏิสัมพันธ์ของท่านกับเว็บไซต์ หรือ
              โฆษณาต่าง ๆ ข้อมูลที่เก็บรวบรวมจากคุกกี้ แท็กพิกเซล
              และเทคโนโลยีการติดตามอื่น ๆ
            </p>
            <p>
              และเราขอยืนยันว่า
              ทางเราไม่มีการเก็บข้อมูลคอนเทนต์ที่ท่านป้อนเข้าสู่กล่องอินพุตเพื่อทำการนับจำนวนคำ
            </p>
            <h1 className="h4">
              <b>การใช้และประมวลผลข้อมูลส่วนบุคคลที่เก็บรวบรวม</b>
            </h1>
            <p>
              ข้อมูลส่วนบุคคลที่เราได้เก็บรวบรวมจากท่านอาจนำมาใช้สำหรับวัตถุประสงค์ดังต่อไปนี้
              <br />- เพื่อบังคับใช้ข้อตกลงและเงื่อนไขและนโยบายต่าง ๆ
              <br />- เพื่อปรับปรุงผลิตภัณฑ์ให้ดียิ่งขึ้น
              <br />
              เราได้ใช้บริการของผู้ประมวลข้อมูลภายนอกดังนี้
              <br />- Firebase
              <br />- Google Analytics
              <br />- Cookie Wow
              <br />- Sentry
            </p>
            <h1 className="h4">
              <b>การเชื่อมต่อไปยังเว็บไซต์อื่น</b>
            </h1>
            <p>
              เว็บไซต์ CanCont
              มีลิงก์ที่เชื่อมต่อไปยังเว็บไซต์อื่นที่ไม่ได้ควบคุมโดยเรา
              เราจะไม่รับผิดชอบต่อแนวทางการปฏิบัติทางด้านความเป็นส่วนตัวของเว็บไซต์อื่น
              ๆ
              เราขอแนะนำให้ท่านได้อ่านนโยบายความเป็นส่วนตัวของแต่ละเว็บไซต์ที่อาจมีการเก็บรวบรวมข้อมูลส่วนบุคคลเมื่อท่านได้ออกจากเว็บไซต์ของเรา
            </p>
            <h1 id="cookie-policy" className="h4">
              <b>นโยบายเกี่ยวกับคุกกี้</b>
            </h1>
            <p>
              CanCount มีการใช้เทคโนโลยีที่เรียกว่า คุกกี้ (Cookies)
              เพื่อเก็บรวบรวม จัดเก็บ
              และติดตามข้อมูลเพื่อวัตถุประสงค์ทางสถิติในการดำเนินการเว็บไซต์
              ท่านสามารถเลือกได้ว่าจะยอมรับหรือปฏิเสธคุกกี้
              หากท่านเลือกที่จะปฏิเสธคุกกี้ อาจจะส่งผลกระทบให้ไม่สามารถใช้ หรือ
              เข้าถึงฟังก์ชันการทำงานบางอย่างของเราได้
            </p>
            <h2 className="h5">
              <b>คุกกี้ที่เราใช้งาน</b>
            </h2>
            <h3 className="h6">
              <b>คุกกี้ที่มีความจำเป็นอย่างยิ่ง (Necessary Cookies)</b>
            </h3>
            <p>
              คุกกี้ที่มีความจำเป็นอย่างยิ่ง
              คุกกี้ประเภทนี้มีความจำเป็นต่อการให้บริการเว็บไซต์ CanCount
              เพื่อให้ท่านสามารถเข้าใช้งานในส่วนต่าง ๆ ของเว็บไซต์ได้
              รวมถึงช่วยจดจำข้อมูลที่ท่านเคยให้ไว้ผ่านเว็บไซต์
            </p>
            <h3 className="h6">
              <b>
                คุกกี้เพื่อการวิเคราะห์/เพื่อประสิทธิภาพ (Analytical Cookies)
              </b>
            </h3>
            <p>
              คุกกี้เหล่านี้ช่วยให้เราและการบริการของบุคคลที่สามสามารถรวบรวมข้อมูลที่เพื่อวัตถุประสงค์ทางสถิติเกี่ยวกับวิธีที่ผู้เยี่ยมชมของเราใช้งานเว็บไซต์
              และเรายังใช้ข้อมูลนี้เพื่อการปรับปรุงการทำงานของเว็บไซต์
              คุกกี้เหล่านี้จะไม่มีข้อมูลส่วนบุคคล เช่น ชื่อ และที่อยู่อีเมล
              และนำมาใช้วิเคราะห์ทางสถิติเท่านั้น
            </p>
            <h3 className="h6">
              <b>คุกกี้เพื่อการโฆษณา (Targeting Cookies)</b>
            </h3>
            <p>
              คุกกี้ประเภทนี้เป็นคุกกี้ที่เกิดจากการเชื่อมโยงเว็บไซต์ของบุคคลที่สาม
              ซึ่งเก็บข้อมูลการเข้าใช้งานและเว็บไซต์ที่ท่านได้เข้าเยี่ยมชม
              ใช้สำหรับการนำเสนอโฆษณาที่เกี่ยวข้องและตรงกับความสนใจของท่านมากขึ้น
              โดยจะถูกใช้งานโดยเครือข่ายสื่อโฆษณา Google หรืออื่นๆ
            </p>
            <h3 className="h6">
              <b>การเปลี่ยนความยินยอมของคุณ</b>
            </h3>
            <p>
              คุณสามารถเปลี่ยนความยินยอมได้โดยการลบคุกกี้ออกจากเบราว์เซอร์
              หรือเปลี่ยนตัวเลือกเดิมโดยการคลิกปุ่มรูปคุกกี้ที่อยู่ทางด้านล่างซ้ายของเว็บไซต์
            </p>
            <h3 className="h6">
              <b>วิธีปิดคุกกี้</b>
            </h3>
            <p>
              ท่านสามารถปิดการทำงานของคุกกี้ได้
              โดยการตั้งค่าเบราว์เซอร์ของท่านและตั้งค่าความเป็นส่วนตัวเพื่อระงับการรวบรวมข้อมูลโดยคุกกี้ในอนาคต
              <br />
              รายละเอียดเพิ่มเติมสามารถศึกษาได้จาก{" "}
              <a href="https://www.internetcookies.com">
                www.internetcookies.com
              </a>
            </p>
            <h1 className="h4">
              <b>การแก้ไขและเปลี่ยนแปลงนโยบายความเป็นส่วนตัว</b>
            </h1>
            <p>
              เราจะพิจารณาปรับปรุงนโยบายการคุ้มครองข้อมูลส่วนบุคคลเป็นครั้งคราว
              เพื่อให้สอดคล้องกับการเปลี่ยนแปลงของการให้บริการ
              โดยเราจะเปิดเผยนโยบายให้ท่านทราบผ่านเว็บไซต์
              อย่างชัดเจนตามความเหมาะสม เมื่อมีการเยี่ยมชมเว็บไซต์
              หรือรับการบริการจากทางเรา
              โปรดอ่านนโยบายการคุ้มครองข้อมูลส่วนบุคคลทุกครั้งเพื่อประโยชน์ของลูกค้าเอง
            </p>
            <h1 className="h4">
              <b>วิธีการติดต่อเรา</b>
            </h1>
            <p>
              หากมีคำถาม ข้อเสนอแนะ หรือต้องการรายละเอียดเพิ่มเติมเกี่ยวกับ
              การประกาศนโยบายความเป็นส่วนตัว หรือต้องการใช้สิทธิ์ของคุณ
              หรือมีข้อสงสัยอื่นใดที่เกี่ยวข้อง โปรดติดต่อ amilazlab@gmail.com
            </p>
            <p>
              นโยบายนี้แก้ไขล่าสุดและมีผลใช้บังคับตั้งแต่วันที่ 20 กรกฎาคม พ.ศ.
              2565
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
